import { ReactConfetti } from '@cleverpoint/react-confetti';

export const ModalConfetti = () => {
  return <ReactConfetti width={400} height={1000} numberOfPieces={500} recycle={false} />;
};
